import { Pipe, PipeTransform } from '@angular/core';
import { constructor } from 'stream';
import { TranslateService } from '../../../shared/services/translate.service';

@Pipe({
  name: 'tipoImpresion'
})
export class TipoImpresionPipe implements PipeTransform {

  constructor (
    private translate: TranslateService
  ) { }
  transform(value: any, args?: any): any {
    switch (value) {
      case '00':
        return this.translate.instant('NORMAL');
      case '01':
        return this.translate.instant('CONJUNTA');
      default:
        return '';
    }
  }

}
